import { Component, effect, input, model, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl } from '@angular/forms';
@Component({
    selector: 'app-season-base-form',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './season-base-form.component.html'
})
export abstract class SeasonBaseFormComponent {
    public readonly enableIcon = input<boolean>(false);
    public isDisabled = model<boolean>(false);

    protected abstract getFormControl(): AbstractControl;

    constructor() {
        effect(() => {
            if (this.isDisabled()) {
                this.getFormControl().disable();
            } else {
                this.getFormControl().enable();
            }
        });
    }
}
